import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomCurrencyPipe } from '../custom-currency.pipe';
import { FileNamePipe } from '../file-name.pipe';
import { ArabicDigitsPipe } from '../arabic-digits.pipe';
import { MatTabsModule } from '@angular/material/tabs';
import { AiChatComponent } from './ai-chat/ai-chat.component';



@NgModule({
  declarations: [
    CustomCurrencyPipe,
    FileNamePipe,
    ArabicDigitsPipe,
    AiChatComponent
  ],
  exports: [
    FileNamePipe,
    CustomCurrencyPipe, // Export it so it can be used in other modules
    ArabicDigitsPipe,
    MatTabsModule,
    AiChatComponent
  ],
  imports: [
    CommonModule,
  ],

})
export class SharedModule { }
